<template>
  <div>
    <ui-popup ref="win" :ui="ui" :padding="0" width="70%" top="150px">
      <div v-if="productList['p' + pId]">
        <div class="p-10 pull-center" :style="'background: #' + productList['p' + pId].color + ';'">
          <img :src="productList['p' + pId].image" style="width: 40%;" />
        </div>
        <div class="p-20">
          <div v-if="type === 'win'" class="pull-center">
            恭喜你抽中了
            <span class="kk-title16 c-red">{{ productList['p' + pId].name }}</span>
          </div>
          <div v-if="type === 'info'" class="pull-center">
            <span class="kk-title16 c-red">{{ productList['p' + pId].name }}</span>
          </div>
          <div v-if="productList['p' + pId].receiving_rules" class="b-all-das p-10 m-t br-6">
            <pre class="f12">{{ productList['p' + pId].receiving_rules }}</pre>
          </div>

          <div class="m-t" v-if="productList['p' + pId].receiving_method === 1 || productList['p' + pId].receiving_method === 2">
            <div v-if="productList['p' + pId].receiving_method === 2">
              <Row class="b-b f12" v-for="(rCode, key) in productList['p' + pId].receiving_obj.r_code" v-if="rCode.is" :key="key">
                <Col :span="8" class="p-10">
                  {{ rCode.name }}
                </Col>
                <Col :span="16" class="p-10 t-r">
                  {{ receivingObj[key] }}
                </Col>
              </Row>
            </div>
            <div class="m-t-lg pull-center">
              <Button @click="clickLink" type="primary">
                {{ productList['p' + pId].receiving_method === 1 ? '点击领取' : '去兑换' }}
              </Button>
            </div>
          </div>
          <div class="m-t" v-if="productList['p' + pId].receiving_method === 5" style="font-size: 80%;">
            <div v-if="sendOutData.mode">
              <Row class="b-b f12">
                <Col :span="8" class="p-10">
                  快递公司
                </Col>
                <Col :span="16" class="p-10 t-r">
                  {{ sendOutData.mode_name }}
                </Col>
              </Row>
              <Row class="b-b f12">
                <Col :span="8" class="p-10">
                  快递单号
                </Col>
                <Col :span="16" class="p-10 t-r">
                  {{ sendOutData.number }}
                </Col>
              </Row>
            </div>
            <div v-else>
              <select-address :project-id="projectId" :apiroot="apiroot" :member="member" :address-data="addressData" :idx="0" title-key="id" :on-change="checkPost"></select-address>
              <div class="m-t pull-center f12-all">
                <Button @click="clickAddress" size="small" type="primary">确认地址</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div :class="lucking.location.box_name + ' p-10 pull-center'">
          <img :src="lucking.location.thank_coming" style="width: 40%; margin-top: 30px; margin-bottom: 30px;" />
        </div>
      </div>
    </ui-popup>
  </div>
</template>
<script>
import { Toast } from 'vant'
import UiPopup from '../ui/popup.vue'
import { SelectAddress } from '@/components/member-address'

export default {
  name: 'LuckingWin',
  components: {
    UiPopup,
    SelectAddress
  },
  props: {
    projectId: {
      type: String
    },
    apiroot: {
      type: String
    },
    lucking: {
      type: Object
    },
    member: {},
    ui: {},
    productList: {}
  },
  data () {
    return {
      pId: null,
      type: 'win',
      code: null,
      receivingObj: {},
      addressData: {},
      sendOutData: {}
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    clickAddress () {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '确认地址...'
      })
      var postData = {}
      postData['sign'] = 'lucking'
      postData['action'] = 'saveAddress'
      postData['project_id'] = this.projectId
      postData['data'] = {}
      postData['data']['code'] = this.code
      postData['data']['address'] = this.addressData
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        Toast.clear()
        if (response.data.code === 1) {
          Toast.success('提交成功')
          this.$refs.win.close()
        } else {
          Toast.fail('提交失败' + (response.data.message ? '，' + response.data.message + '。' : '。'))
        }
      })
    },
    checkPost (idx) {
    },
    clickLink () {
      if (this.productList['p' + this.pId].receiving_obj.type === 'link') {
        window.location.href = this.productList['p' + this.pId].receiving_obj.link
      }
    },
    winLucking (code, pId, receivingObj) {
      this.type = 'win'
      this.code = code
      this.pId = pId
      this.receivingObj = receivingObj
      this.$refs.win.open('')
    },
    infoLucking (code, pId, receivingObj) {
      this.type = 'info'
      this.code = code
      this.pId = pId
      this.receivingObj = receivingObj
      if (receivingObj && receivingObj.address) {
        this.addressData = receivingObj.address
        if (receivingObj.send_out) {
          this.sendOutData = receivingObj.send_out
        }
      }

      this.$refs.win.open('')
    }
  },
  mounted () {
    // this.winLucking(5, {})
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lucking/win.vue